/**
 * Bulk-Apply im „Bereit"-Tab (T8) braucht ALLE pending `auto_safe`-Suggestion-IDs
 * eines Laufs — nicht nur die aktuell in der Liste geladene Seite. Die
 * Suggestions-API liefert weder `total` noch einen konfigurierbaren `page_size`
 * (serverseitig fix 50, `app/core/channel_content_gen/suggestion_repository.py:29`)
 * — daher hier die sauberste Lösung ohne API-Änderung: Seiten sequenziell
 * abfragen, bis eine Seite < 50 Treffer liefert (Ende) oder eine Sicherheitsgrenze
 * von 10 Seiten (= 500 Vorschläge) erreicht ist.
 */
import { listSuggestions } from '@/lib/api/channel-content-bulk'

const PAGE_SIZE = 50
const MAX_PAGES = 10

export async function collectPendingSuggestionIds(runId: string): Promise<string[]> {
  const ids: string[] = []
  for (let page = 1; page <= MAX_PAGES; page++) {
    const { items } = await listSuggestions({ run_id: runId, route: 'auto_safe', status: 'pending', page })
    ids.push(...items.map((item) => item.id))
    if (items.length < PAGE_SIZE) break
  }
  return ids
}
